"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FINANCIAL_DISCOUNT_REQUEST_EXAMPLES = exports.applyDiscountRequestSchema = void 0;
/**
 * Request contract for the 1 Discount endpoint —
 * `DiscountApplicationService.applyDiscount`
 * (`backend/src/modules/financial/application/discount.application-service.ts`,
 * frozen, Stage 5C.3). This is the ONLY Discount Management capability
 * with an Application Service wrapper — `DiscountManagementService
 * .createRule` (Domain Service, Stage 5C.2) has no Application
 * Service, so no "create a discount rule" contract exists — see
 * `FINANCIAL-API-REVIEW.md`.
 */
const zod_1 = require("zod");
const financial_common_request_1 = require("./financial-common.request");
exports.applyDiscountRequestSchema = zod_1.z.object({
    ruleId: zod_1.z.string().uuid(),
    baseAmount: zod_1.z.number().int().positive(),
    sourceEntityType: zod_1.z.string().min(1),
    sourceEntityId: zod_1.z.string().uuid(),
    ...financial_common_request_1.financialWorkflowExtrasShape,
});
exports.FINANCIAL_DISCOUNT_REQUEST_EXAMPLES = {
    applyDiscount: {
        ruleId: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
        baseAmount: 100000,
        sourceEntityType: 'ChargeMaster',
        sourceEntityId: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
    },
};
//# sourceMappingURL=financial-discount.request.js.map